import { DatePicker, Table, message, Row, Col, Button, Modal, Upload, Form, Input, Tabs, Checkbox, Image } from 'antd';
import React, { useEffect, useState, useRef, useContext } from 'react';
import axios from 'axios';
import { Navigate, Outlet, useNavigate, useLocation, useParams } from 'react-router-dom'
import { ExclamationCircleFilled, HeartOutlined, PlusOutlined, EditOutlined } from '@ant-design/icons';
import FeedbackModal from './components/FeedbackModal';
import PreviewImgModal from './components/Media/PreviewImgModal';
import dayjs from 'dayjs'
import Carousel_news_ticker from './components/Carousel_news_ticker';
const { confirm } = Modal;
const FeedbackForm = () => {
    const navigate = useNavigate()
    const [form] = Form.useForm();
    const [title, setTitle] = useState('新增需求');
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('FF6B90');
    const [editcard, setEditCard] = useState({});
    const [fileList, setFileList] = useState([]);
    const [modal_img, set_modal_img] = useState(false);
    const [img, setImg] = useState('');
    const [messageApi, contextHolder] = message.useMessage();
    const [form_data, set_form_data] = useState([]);
    const [data, setData] = useState([
        //     {
        //     key: 1,
        //     name: 'name_serial',
        //     placeholder: '需求修改單編號',
        //     type: 'input',
        //     value: '',
        //     required: 'true',
        // }, 
        {
            key: 2,
            name: 'user_name',
            placeholder: '客戶名稱',
            type: 'input',
            value: '',
            disabled: true
        }, {
            key: 3,
            name: 'first_insert_time',
            placeholder: '填表日期',
            type: 'datepicker',
            value: dayjs(),
            required: true,
            disabled: true
        }, {
            key: 4,
            name: 'contact_person_name',
            placeholder: '聯絡人',
            type: 'input',
            value: '',
            required: true,
            message: '如何稱呼聯絡人'
        }, {
            key: 5,
            name: 'contact_phone',
            placeholder: '客戶電話',
            type: 'input',
            value: '',
        }])

    useEffect(() => {
        axios
            .get('/cramSchool/api/permission')
            .then((response) => {
                let user_name = '';
                response.data.forEach(each_item => {
                    user_name = each_item.user_name
                });
                form.setFieldValue('user_name', user_name)
            })
    }, [])
    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(1);
    const handleAdd = (file_id) => {
        let newData = {
            key: count,
            ...editcard,
            file_id: file_id
        };
        setDataSource(prev => [...prev, newData]);
        setCount(count + 1);
        setOpen(false);
        get_picture([newData])
    };
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['key']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/crmFeedBack/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setDataSource(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.key) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    const handleChange = (name, value) => {
        set_form_data(pre => {
            return ({
                ...pre,
                [`${name}`]: value
            })
        })
    }
    const onSubmit = () => {
        // if (JSON.stringify(form_data) == '{}' && dataSource.length == 0) {
        //     messageApi.open({
        //         type: 'error',
        //         content: '新增失敗，資料請填寫完整',
        //     });
        // }
        if (dataSource.length === 0) {
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫需求',
            });
            return;
        }
        form
            .validateFields()
            .then(values => {
                let form_data = form.getFieldsValue();
                let data_tmp = [
                    {
                        ...form_data, feedback_request: [...dataSource], file_id: [fileList.map(map_item => map_item.uid)],
                        first_insert_time: dayjs(form_data['first_insert_time']).format('YYYY-MM-DD')
                    }
                ]
                // console.log(data_tmp); 
                // console.log(data_tmp);
                // return;
                axios
                    .post('/crmFeedBack/feedback', data_tmp)
                    .then((response) => {
                        if (response.data.status == 'failure') {
                            messageApi.open({
                                type: 'error',
                                content: '新增失敗',
                            });
                        } else {
                            setOpen(false);
                            messageApi.open({
                                type: 'success',
                                content: '新增成功',
                            });
                            setTimeout(() => {
                                navigate(0)
                            }, 1000)
                        }
                    })
            })

    }
    const handleEdit = (file_id) => {
        setDataSource(pre => {
            return (
                pre.map((value) => {
                    if (value.key == editcard.key) {
                        return ({ ...editcard, file_id: file_id, file_url: [] })
                    } else {
                        return ({ ...value })
                    }
                })
            )
        });
        get_picture([{ ...editcard, file_id: file_id, file_url: [] }])
        setOpen(false);

    }
    const handleDelete = () => {

    }
    const handleOnEdit = (key) => {
        setTitle('修改需求');
        setColor('f09a45');
        setEdit(true);
        dataSource.map((value, index) => {
            if (value.key == key) {
                setEditCard(value);
            }
        })
        setOpen(true)
    }
    const showConfirm = (e) => {
        confirm({
            title: '確認要刪除此需求嗎？',
            icon: <ExclamationCircleFilled />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleDeleteRow(e);
            },
        });
    };

    const showConfirmPic = (e) => {
        confirm({
            title: '確認要刪除此張圖片嗎？',
            icon: <ExclamationCircleFilled />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                remove(e);
            },
        });
    };
    const handleDeleteRow = (key) => {
        setDataSource(prev => prev.filter(filter_item => filter_item.key !== key));
    }
    const handlePreview = (e) => {
        setImg(e.url);
        set_modal_img(true);
    }
    const remove = (e) => {
        setFileList(prev => prev.filter(filter_item => filter_item.uid !== e.uid));
    }
    const handleUpload = (e) => {
        e = e.file;
        let form_data = new FormData();
        form_data.append('inputFile', e);
        axios
            .post(`/crmFeedBack/file`, form_data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            .then((response) => {
                let file_id = parseInt(response.data.file_id);
                const dataurl = URL.createObjectURL(e);
                setFileList(
                    prev => {
                        return ([
                            ...prev,
                            {
                                uid: file_id,
                                url: dataurl
                            }
                        ])
                    }
                );
            })
    }
    return (
        <>
            {contextHolder}
            <PreviewImgModal
                modal_img={modal_img}
                set_modal_img={set_modal_img}
                img={img}
            ></PreviewImgModal>
            <FeedbackModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleAdd}
            ></FeedbackModal>
            <Row gutter={[8, 8]} style={{ paddingTop: '20px' }}>
                {/* <Col span={24}>
                    <h2>使用者測試及意見回饋需求修改單</h2>
                </Col> */}
                <Col span={24}>
                    <Form autoComplete="off"
                        form={form}
                        wrapperCol={{
                        }}
                        labelCol={{
                        }}
                        labelAlign={'left'}
                    >
                        <Row gutter={[24]}>
                            {data && data.map((value, i) => {
                                if (value.type == 'input') {
                                    return (
                                        <Col span={6}>
                                            <Form.Item
                                                // {...formItemLayout}
                                                name={value.name}
                                                label={value.placeholder}
                                                rules={[
                                                    {
                                                        required: value.required,
                                                        message: value.message,
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    disabled={value.disabled}
                                                />
                                            </Form.Item>
                                        </Col>
                                    )
                                } else {
                                    return (
                                        <Col span={6}>
                                            <Form.Item
                                                // {...formItemLayout}
                                                name={value.name}
                                                label={value.placeholder}
                                                initialValue={value.value}
                                            // rules={[
                                            //     {
                                            //         required: `${value.required}`,
                                            //         message: '',
                                            //     },
                                            // ]}
                                            >
                                                <DatePicker style={{ width: '100%' }}
                                                    disabled={value.disabled}
                                                />
                                            </Form.Item>
                                        </Col>
                                    )
                                }

                            })}
                        </Row>
                        <Col span={24} hidden>
                            <Row gutter={[8, 8]} align={'middle'}>
                                <Col span={2}>上傳圖片</Col>
                                <Col span={22}>
                                    <Upload
                                        accept="image/png,image/jpeg"
                                        customRequest={handleUpload}
                                        listType="picture-card"
                                        fileList={fileList}
                                        onPreview={handlePreview}
                                        onRemove={e => showConfirmPic(e)}
                                        // onChange={handleUpload} 
                                        beforeUpload={false}
                                        multiple
                                    >
                                        <div>
                                            <PlusOutlined />
                                            <div
                                                style={{
                                                    marginTop: 8,
                                                }}
                                            >
                                                上傳圖片
                                            </div>
                                        </div>
                                    </Upload>
                                </Col>
                                {/* <Col span={20}>
                                                    {more_pic == true ? null :
                                                        <Row align={'end'} >
                                                            <Col style={{ cursor: 'pointer', textDecoration: 'underline' }}>更多圖片</Col>
                                                        </Row>}
                                                </Col> */}
                                <Col span={2}></Col>
                                <Col span={22}>＊請注意圖片大小，限制在2MB以內</Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Button
                                className='example'
                                onClick={e => { setTitle('新增需求'); setColor('FF6B90'); setEditCard({}); setEdit(false); setOpen(true) }}
                                type="primary"
                                style={{
                                    marginBottom: 16,
                                }}
                            >
                                新增需求
                            </Button>
                        </Col>
                        <Col span={24}>
                            <Table
                                // bordered
                                tableLayout={'fixed'}
                                scroll={{ x: 'max-content' }}
                                dataSource={dataSource}
                                columns={[
                                    {
                                        title: '編號',
                                        key: 'key',
                                        align: 'center',
                                        render: (text, record, index) => (index + 1)
                                    },
                                    /* {
                                        title: '需求修改項目',
                                        key: 'item',
                                        dataIndex: 'item',
                                        align: 'center',
                                    }, */
                                    {
                                        title: '修改原因',
                                        key: 'reason',
                                        dataIndex: 'reason',
                                        align: 'center',
                                    },
                                    /* {
                                        title: '驗收測試範例',
                                        key: 'accepting_test',
                                        dataIndex: 'accepting_test',
                                        align: 'center',
                                    }, */
                                    {
                                        title: '照片',
                                        sorter: false,
                                        render: (text, record, index) => (<>
                                            <div
                                                style={{
                                                    padding: 0,
                                                    margin: 'auto',
                                                    width: '150px',
                                                }}
                                            >
                                                <Carousel_news_ticker
                                                    file_url={record['file_url']}
                                                />
                                            </div>
                                            {/* <Row
                                                style={{
                                                    margin: 0,
                                                    maxHeight: '64px',
                                                    width: '64px',
                                                    overflowX:'scroll'
                                                }}
                                                wrap={false}
                                            >
                                                {record['file_url'] ? record['file_url'].map((tmp, index) => (<>
                                                    <Col>
                                                        <Image width='64px' height={'auto'} src={tmp} />
                                                    </Col>
                                                </>)) : null}
                                            </Row> */}
                                        </>),
                                    },
                                    {
                                        title: '編輯',
                                        align: 'center',
                                        render: (text, record, index) => (<>
                                            <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => handleOnEdit(record.key)}>編輯</Button>
                                            <Button type="text" style={{ color: 'red' }} onClick={(e) => showConfirm(record.key)}>刪除</Button>
                                        </>)
                                    }]}
                                pagination={false}
                            />
                        </Col>
                    </Form>
                </Col>
                <Col span={24}>
                    <Row justify="center" style={{ padding: '10px' }}>
                        <Col>
                            <Button className='example' block style={{ background: '#566FB8' }} size='large' onClick={onSubmit} >
                                <div style={{ color: '#ffffff' }}>
                                    送出
                                </div>
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}
export default FeedbackForm;